import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
// routes
import { useRouter } from 'src/routes/hook';
//
import { useAuthContext } from '../hooks';
import { getFirstAccessiblePath } from '../utils/first-accessible-path';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter();

  const { authenticated, user } = useAuthContext();

  const check = useCallback(() => {
    if (authenticated) {
      // Land on the first item their sidebar actually shows. Sending them
      // to a hard-coded `/dashboard` when they don't have the summary
      // permission produces a blank/forbidden landing — the logo click
      // (which routes through this guard) now respects the user's real
      // access instead.
      router.replace(getFirstAccessiblePath(user));
    }
  }, [authenticated, user, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};